import { c as _c } from "react/compiler-runtime";
import type { MetricsObject } from '@svs/nova-poolbetting/schema/sport';
import type { ReactNode } from 'react';
import { Trend } from './Trend';
type TipsinfoValueProps = {
  metrics: MetricsObject;
  title: string;
  hasTrend?: boolean;
  trendResetScope?: string;
};
const defaultEvent1X2Values = ['-', '-', '-'];

/**
 * Tipsinfo value component.
 *
 * @param root0 props
 * @param root0.metrics metrics for event
 * @param root0.title title for the metrics for accessibility
 * @param root0.hasTrend whether to apply trend to the value, default false
 * @param root0.trendResetScope scope key used to reset trend state when context changes
 * @returns tipsinfo value component
 */
export function TipsinfoValue(t0) {
  const $ = _c(11);
  const {
    metrics,
    title,
    hasTrend,
    trendResetScope
  } = t0;
  const values = metrics.current.value.length > 0 ? metrics.current.value : defaultEvent1X2Values;
  let cell;
  if ($[0] !== hasTrend || $[1] !== metrics.valueType || $[2] !== title || $[3] !== trendResetScope || $[4] !== values) {
    cell = [];
    for (const [index, value] of values.entries()) {
      const valueToShow = metrics.valueType === "percentage" && value !== undefined && value !== null ? Math.round(Number(value)) : value;
      const suffix = metrics.valueType === "percentage" ? "%" : "";
      const displayValue = value === undefined ? "-" : `${valueToShow}${suffix}`;
      cell.push(<td className="w-full" key={index}>{hasTrend ? <Trend currentValue={value} resetKey={`${trendResetScope ?? title}-${index}`}>{displayValue}</Trend> : displayValue}</td>);
    }
    $[0] = hasTrend;
    $[1] = metrics.valueType;
    $[2] = title;
    $[3] = trendResetScope;
    $[4] = values;
    $[5] = cell;
  } else {
    cell = $[5];
  }
  let t1;
  if ($[6] !== title) {
    t1 = <th className="sr-only" scope="row">{title}</th>;
    $[6] = title;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== cell || $[9] !== t1) {
    t2 = <tr className="flex justify-between gap-x-1.5 text-center">{t1}{cell}</tr>;
    $[8] = cell;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}